import React, { useEffect, useState } from 'react'
import { fnGetValueByKey } from '../../helpers/functions'

const CardContextExpansiveDynamic = ({ contextBlock, isRenderModal = false }) => {
  const childs = contextBlock

  const [rowData, setRowData] = useState([])
  const [expanded, setExpanded] = useState(false)

  const handleGetData = async () => {
    try {
      let resultset = JSON.parse(fnGetValueByKey(childs, "PROCEDURE_RESULTSET"))
      if(resultset) setRowData(resultset)
    } catch (error) {
      console.warn("Erro ao parsear CONTEXTO_EXPANSIVEL_001: ", error)
    }
  }

  useEffect(() => {
    if (!childs) return 
    handleGetData()
  }, [childs])

  if (!childs || childs.length === 0) return 

  console.log("rowData[1]: ", rowData[1])

  return (
    <div className={"card-context-dynamic-wrapper d-flex flex-column"}>
        <div
          className={`card-context-dynamic ${isRenderModal ? 'p-3' : 'p-4'}`}
        >
          <div className='row'>
            <div className='col-5 border-2 border-end border-color-cinza2 pe-5'>
              <div className='row'>
                {rowData[0] && rowData[0]?.slice(0, 4).map((item, index) => {

                  return (
                    <div
                      key={index}
                      className={`d-flex flex-column mb-3 ${item.largura}`}
                    >
                      <span className={`font-size-14 font-w-500 mb-1 text-color-cinza5 flex-wrap`}>
                        {item.titulo}
                      </span>
                      <span className=" font-size-14 font-w-600 text-color-cinza5 flex-wrap">
                        {item.valor}
                      </span>
                    </div>
                  )
                })}
              </div>
              {expanded && (
                <div className='row mt-4'>
                  {rowData[0] && rowData[0]?.slice(4, 99).map((item, index) => {

                    return (
                      <div
                        key={index}
                        className={`d-flex flex-column mb-3 ${item.largura}`}
                      >
                        <span className={`font-size-14 font-w-500 mb-1 text-color-cinza5 flex-wrap`}>
                          {item.titulo}
                        </span>
                        <span className=" font-size-14 font-w-600 text-color-cinza5 flex-wrap">
                          {item.valor}
                        </span>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
            <div className='col ps-5'>
              <div className='row'>
                {rowData[1] && rowData[1]?.map((item, index) => {

                  return (
                    <div
                      key={index}
                      className={`d-flex flex-column mb-3 ${item.largura}`}
                    >
                      {item.titulo && (                        
                        <span className={`font-size-16 font-w-600 mb-1 text-color-azul1 flex-wrap text-break`}>
                          {item.titulo}
                        </span>
                      )}
                      {item.subtitulo && (
                        <span className=" font-size-14 font-w-600 mb-1 text-color-cinza5 flex-wrap text-break">
                          {item.subtitulo}
                        </span>
                      )}
                      {!!item.descricao && expanded && (
                        <span className=" font-size-12 text-color-cinza5 flex-wrap text-break">
                          {item.descricao}
                        </span>
                      )}
                      {item?.html && expanded && (
                        <div dangerouslySetInnerHTML={{ __html: `${item.html}` }}></div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
            <div style={{width: 70 }} className='col-1 d-flex align-items-center justify-content-center'>
              <button
                type="button"
                className="btn bg-transparent border-0"
                onClick={() => setExpanded(!expanded)}
              >
                <i class={`fa-solid fa-chevron-${expanded ? "up" : "down"} text-color-azul1`}></i>
              </button>
            </div>
          </div>
        </div>
    </div>
  )
}

export default CardContextExpansiveDynamic
